// extracted by mini-css-extract-plugin
export default {"container":"AttachmentFeed__container___xrRzO","seeOthers":"AttachmentFeed__seeOthers___Mg5Iy","seeOthersDisable":"AttachmentFeed__seeOthersDisable___cHxUL"};